import { useState, useEffect } from "react";
import logo from '../images/logo.svg';

const PriceCalculator = () => {
  const [modulePreis, setModulePreis] = useState(0);
  const [anzahlModule, setAnzahlModule] = useState(4);
  const [elektroinstallation, setElektroinstallation] = useState(false);
  const [hersteller, setHersteller] = useState("");
  const [wechselrichter, setWechselrichter] = useState(0);
  const [speicher, setSpeicher] = useState(0);
  const [smartMeter, setSmartMeter] = useState(0);
  const [sonderoptionen, setSonderoptionen] = useState({
    flachdach: false,
    tegalit: false,
    unterverteilung: false,
    zaehlerschrank: false,
    tiefenerder: false,
    wallbox: false,
    gerüstL: false,
    zählerzusammenlegung: false,
    zwischenzähler: false,
    zählerschranksanierung: false,
  });
  const [zusatzKosten, setZusatzKosten] = useState(0);

  const preise = {
    module: {
      "Trina Vertex S+ Doppelglas 445Wp": 290,
      "Aiko NeoStar S2+ Full Black 460Wp": 300,
    },
    wechselrichter: {
      "5kW": 1979,
      "6kW": 2109,
      "8kW": 2164,
      "10kW": 2234,
      "12kW": 2534,
      "15kW": 2764,
      "17kW": 2894,
      "20kW": 3019,
      "25kW": 3424,
    },
    speicher: {
      "5kWh": 2670,
      "6kWh": 3000,
      "8kWh": 3366,
      "9kWh": 3750,
      "10kWh": 5340,
      "15kWh": 8010,
      "16kWh": 6732,
      "20kWh": 10680,
      "24kWh": 10098,
      "25kWh": 13350,
      "30kWh": 16020,
      "32kWh": 13464,
      "40kWh": 17330,
    },
    smartmeter: {
      "Sigen Sensor TP-CT-DH": 189,
      "Sigen Gateway HomeMax TP": 1390,
    },
    sonderoptionen: {
      flachdach: 15, // Pro Modul
      tegalit: 20,   // Pro Modul
      Blechziegel: 69,   // Pro Modul
      unterverteilung: 250,
      zaehlerschrank: 900,
      tiefenerder: 900,
      wallbox: 1850,
      gerüstL: 400,
      zählerzusammenlegung: 350,
      zwischenzähler: 250,
      zählerschranksanierung: 250,
    },
  };

  const berechnen = () => {
    const moduleKosten = modulePreis * anzahlModule;
    const elektroKosten = elektroinstallation ? 2500 : 0;

    const sonderKosten = Object.keys(sonderoptionen).reduce((sum, key) => {
      if (!sonderoptionen[key]) return sum;

      // Multiplikation mit Modulanzahl bei Flachdach/Tegalit
      if (key === "flachdach" || key === "tegalit") {
        return sum + preise.sonderoptionen[key] * anzahlModule;
      }
      return sum + preise.sonderoptionen[key];
    }, 0);

    const standardposten = 2972;
    const zusatzKostenNum = Number(zusatzKosten);

    return {
      moduleKosten,
      elektroKosten,
      wechselrichter,
      speicher,
      smartMeter,
      sonderKosten,
      standardposten,
      zusatzKosten: zusatzKostenNum,
      gesamt: moduleKosten +
             elektroKosten +
             wechselrichter +
             speicher +
             smartMeter +
             sonderKosten +
             standardposten +
             zusatzKostenNum,
    };
  };

  const details = berechnen();

  useEffect(() => {
    if (hersteller === "") {
      setWechselrichter(0);
      setSpeicher(0);
      setSmartMeter(0);
      setSonderoptionen({
        flachdach: false,
        tegalit: false,
        unterverteilung: false,
        zaehlerschrank: false,
        tiefenerder: false,
        wallbox: false,
        gerüstL: false,
        zählerzusammenlegung: false,
        zwischenzähler: false,
        zählerschranksanierung: false,
      });
    } else if (hersteller !== "Sigenergy") {
      setWechselrichter(0);
      setSpeicher(0);
      setSmartMeter(0);
      setSonderoptionen(prev => ({
        ...prev,
        flachdach: false,
        tegalit: false,
        unterverteilung: false,
        zaehlerschrank: false,
        tiefenerder: false,
        wallbox: false,
        gerüstL: false,
        zählerzusammenlegung: false,
        zwischenzähler: false,
        zählerschranksanierung: false,
      }));
    }
  }, [hersteller]);



  return (

    <div className="p-6 max-w-3xl mx-auto bg-white shadow-lg rounded-xl">
      {/* Add logo here */}
      <div className="text-center mb-6">
        <img
          src={logo}
          alt="Schmid Energieberatung Logo"
          className="mx-auto max-w-xs mb-4"
        />
      </div>
      <h2 className="text-2xl font-bold text-center mb-4">Photovoltaik Preiskalkulator</h2>
      <div className="space-y-4">
        <div>
          <label className="block font-medium">Solarmodule inkl. Montage & UK:</label>
          <select
            className="w-full p-2 border rounded"
            onChange={(e) => setModulePreis(preise.module[e.target.value])}
          >
            <option value="0">Bitte wählen</option>
            {Object.entries(preise.module).map(([label, price]) => (
              <option key={label} value={label}>
                {label} - {price}€
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block font-medium">Anzahl der Module (0-60):</label>
          <input
            type="number"
            value={anzahlModule}
            onChange={(e) => setAnzahlModule(e.target.value)}
            onBlur={() => {
              if (anzahlModule < 0) setAnzahlModule(4);
              else if (anzahlModule > 60) setAnzahlModule(60);
            }}
            min="4"
            max="60"
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="elektro"
            onChange={(e) => setElektroinstallation(e.target.checked)}
          />
          <label htmlFor="elektro">Elektroinstallation & AC-Montage (2.500€)</label>
        </div>

        <div>
          <label className="block font-medium">Hersteller:</label>
          <select
            className="w-full p-2 border rounded"
            onChange={(e) => setHersteller(e.target.value)}
          >
            <option value="">Bitte wählen</option>
            <option value="Sigenergy">Sigenergy</option>
            <option value="EcoFlow">EcoFlow</option>
          </select>
        </div>

        {hersteller === "Sigenergy" && (
          <>
            <div>
              <label className="block font-medium">Wechselrichter:</label>
              <select
                className="w-full p-2 border rounded"
                onChange={(e) => setWechselrichter(preise.wechselrichter[e.target.value])}
              >
                <option value="0">Bitte wählen</option>
                {Object.entries(preise.wechselrichter).map(([key, price]) => (
                  <option key={key} value={key}>
                    {key} - {price}€
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block font-medium">Stromspeicher:</label>
              <select
                className="w-full p-2 border rounded"
                onChange={(e) => setSpeicher(preise.speicher[e.target.value])}
              >
                <option value="0">Bitte wählen</option>
                {Object.entries(preise.speicher).map(([key, price]) => (
                  <option key={key} value={key}>
                    {key} - {price}€
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block font-medium">Smartmeter oder Gateway:</label>
              <select
                className="w-full p-2 border rounded"
                onChange={(e) => setSmartMeter(preise.smartmeter[e.target.value])}
              >
                <option value="0">Bitte wählen</option>
                {Object.entries(preise.smartmeter).map(([key, price]) => (
                  <option key={key} value={key}>
                    {key} - {price}€
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block font-medium">Sonderoptionen:</label>
              {Object.entries(preise.sonderoptionen).map(([key, price]) => (
                <div key={key} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id={key}
                    onChange={(e) =>
                      setSonderoptionen((prev) => ({ ...prev, [key]: e.target.checked }))
                    }
                  />
                  <label htmlFor={key}>
                    {key === "flachdach" && "Flachdach"}
                    {key === "tegalit" && "Tegalit"}
                    {key === "gerüstL" && "Gerüst (L)"}
                    {!["flachdach", "tegalit", "gerüstL"].includes(key) && 
                      key.charAt(0).toUpperCase() + key.slice(1)}
                    {["flachdach", "tegalit"].includes(key) 
                      ? ` (${price}€/Modul)` 
                      : ` (${price}€)`}
                  </label>
                </div>
              ))}
            </div>
          </>
        )}

        <div>
          <label className="block font-medium">Ausgleich für Logistik und Dienstleistungen:</label>
          <input
            type="number"
            value={zusatzKosten}
            onChange={(e) => {
              let value = Number(e.target.value);
              if (value < 0) value = 0;
              if (value > 3000) value = 3000;
              setZusatzKosten(value);
            }}
            min="0"
            max="3000"
            className="w-full p-2 border rounded"
          />
        </div>
      </div>

      <div className="mt-6 bg-gray-100 p-4 rounded-lg">
        <h3 className="text-lg font-semibold mb-2">Rechnungspositionen</h3>
        <div className="space-y-2">
          <div className="flex justify-between font-bold">
            <span>Solarmodule ({modulePreis}€ x {anzahlModule}):</span>
            <span>{details.moduleKosten}€</span>
          </div>
          
          {details.elektroKosten > 0 && (
            <div className="flex justify-between font-bold">
              <span>Elektroinstallation:</span>
              <span>{details.elektroKosten}€</span>
            </div>
          )}

          {wechselrichter > 0 && (
            <div className="flex justify-between font-bold">
              <span>Wechselrichter:</span>
              <span>{details.wechselrichter}€</span>
            </div>
          )}

          {speicher > 0 && (
            <div className="flex justify-between font-bold">
              <span>Stromspeicher:</span>
              <span>{details.speicher}€</span>
            </div>
          )}

          {smartMeter > 0 && (
            <div className="flex justify-between font-bold">
              <span>Smartmeter/Gateway:</span>
              <span>{details.smartMeter}€</span>
            </div>
          )}

          {Object.entries(sonderoptionen).map(([key, value]) => (
            value && (
              <div key={key} className="flex justify-between font-bold">
                <span>
                  {key === "flachdach" && "Flachdach"}
                  {key === "tegalit" && "Tegalit"}
                  {key === "gerüstL" && "Gerüst (L)"}
                  {!["flachdach", "tegalit", "gerüstL"].includes(key) && 
                    key.charAt(0).toUpperCase() + key.slice(1)}
                </span>
                <span>
                  {["flachdach", "tegalit"].includes(key)
                    ? `${preise.sonderoptionen[key]}€ × ${anzahlModule} = ${preise.sonderoptionen[key] * anzahlModule}€`
                    : `${preise.sonderoptionen[key]}€`}
                </span>
              </div>
            )
          ))}

          <div className="flex justify-between font-bold">
            <span>Standardposten:</span>
            <span>{details.standardposten}€</span>
          </div>

          {zusatzKosten > 0 && (
            <div className="flex justify-between font-bold">
              <span>ÜV:</span>
              <span>{details.zusatzKosten}€</span>
            </div>
          )}
        </div>
      </div>

      <div className="mt-6 bg-gray-200 p-4 rounded-lg">
        <div className="flex justify-between font-semibold text-xl">
          <span>Gesamtbetrag:</span>
          <span>{details.gesamt}€</span>
        </div>
      </div>
    </div>
  );
};

export default PriceCalculator;
